export default function cap(text, maxLen = 7) {
  text = text.toString();
  const len = text.length;
  if (len <= maxLen) {
    return text;
  } else {
    return text.slice(0, maxLen) + "...";
  }
}
